var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.306 12.2727V18.0818H23.5436C23.1819 19.95 22.0964 21.5318 20.4684 22.5955L25.4359 26.3728C28.3302 23.7547 30 19.9092 30 15.341C30 14.2774 29.9026 13.2546 29.7217 12.2729L15.306 12.2727Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72797 17.855L5.6076 18.6955L1.64182 21.7227C4.16039 26.6181 9.3224 30 15.3057 30C19.4383 30 22.9031 28.6636 25.4356 26.3728L20.468 22.5955C19.1044 23.4955 17.365 24.041 15.3057 24.041C11.3261 24.041 7.94491 21.4092 6.73423 17.8637L6.72797 17.855Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64183 8.27722C0.598274 10.2953 0 12.5726 0 14.9998C0 17.4271 0.598274 19.7044 1.64183 21.7225C1.64183 21.736 6.73473 17.8497 6.73473 17.8497C6.42861 16.9498 6.24767 15.9953 6.24767 14.9997C6.24767 14.0041 6.42861 13.0496 6.73473 12.1496L1.64183 8.27722Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.306 5.97271C17.5603 5.97271 19.564 6.73633 21.1642 8.20907L25.5473 3.91368C22.8895 1.48645 19.4388 0 15.306 0C9.32271 0 4.16039 3.36817 1.64182 8.27727L6.73457 12.15C7.94508 8.6045 11.3264 5.97271 15.306 5.97271Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.2f7fcbbb1a4e8d0ae421946ded3a7e60.svg";
export { ForwardRef as ReactComponent };